import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [actor, setActor] = useState(null); // null=checking, false=unauth, object=authed
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setActor(data);
    } catch (e) {
      setActor(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const therapistLogin = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setActor(data);
    return data;
  };
  const therapistRegister = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    setActor(data);
    return data;
  };
  const studentLogin = async (username, pin) => {
    const { data } = await api.post("/auth/student-login", { username, pin });
    setActor(data);
    return data;
  };
  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) { /* ignore */ }
    setActor(false);
  };

  return (
    <AuthContext.Provider value={{ actor, loading, therapistLogin, therapistRegister, studentLogin, logout, refresh, setActor }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() { return useContext(AuthContext); }
